module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditInternalNumber',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить внутренний номер " + _vm._s(_vm.item.number))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить внутренний номер")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.number.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-number"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.number),
      expression: "newDataItem.number",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-number"
    },
    domProps: {
      "value": (_vm.newDataItem.number)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "number", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.number.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.number.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Внутренний номер должн быть указан и состоять из " + _vm._s(_vm.$v.newDataItem.number.$params.minLength.min) + " цифр")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователи не заданы",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "select": _vm.attachUser,
      "remove": _vm.detachUser,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить внутренний номер")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ba9e736", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-5ba9e736"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalAdminAddEditInternalNumber.vue
// module id = 1042
// module chunks = 1